/***
 *
 *   HEADER USER MENU STYLES
 *   Ported from ui-reference/src/components/layouts/header-user-menu.tsx.
 *
 **********/

const Style = {
    trigger: `rounded-full ring-offset-background transition-[box-shadow]
    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2`,

    // The reference's DropdownMenuLabel is a two-line block; Dropdown's heading
    // item is one line, so the two lines are stacked here instead.
    name: 'block truncate text-sm font-medium text-text-primary',
    email: 'block truncate text-xs font-normal text-text-muted',
};

export default Style;
